import React from "react";
import { Card, CardHeader, Typography, Divider, Box } from "@mui/material";

const GeneralInfo = ({ generalInfo = [] }) => {
  return (
    <Card elevation={3} sx={{ p: 3, maxWidth: 900, mx: "auto" }}>
      <CardHeader
        title={
          <Typography variant="h5" fontWeight="bold" align="center">
            General Information
          </Typography>
        }
      />
      <Divider sx={{ my: 2 }} />

      {Array.isArray(generalInfo) && generalInfo.length > 0 ? (
        generalInfo.map((info, index) => (
          <Box key={index} sx={{ mb: 2 }}>
            <Typography variant="h6" fontWeight="bold">
              {info.title}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {info.content}
            </Typography>
          </Box>
        ))
      ) : (
        <Typography variant="body2" color="textSecondary" align="center">
          No general information available.
        </Typography>
      )}
    </Card>
  );
};

export default GeneralInfo;
